import { type ReactNode } from 'react'
import { type WithPermissionEntityId } from '@terros/common'
import { useQueryState, parseAsBoolean } from 'nuqs'
import { TButton } from '../buttons'
import { TDrawer } from '../terros'
import { PermissionContent } from './PermissionContent'
import { type PermissionButtonProps } from './ViewPermissionButton'

export const OptimisticPermissionButton = ({
  entityId,
  drawerTitle,
  buttonProps,
}: Omit<PermissionButtonProps, 'entityId' | 'permissionType' | 'permissionEntityId'> &
  WithPermissionEntityId): ReactNode => {
  const [viewPermissions, setViewPermissions] = useQueryState(
    `viewPermissionsFor${entityId}`,
    parseAsBoolean.withDefault(false)
  )

  const open = (): void => {
    setViewPermissions(true)
  }

  const close = (): void => {
    setViewPermissions(false)
  }

  return (
    <>
      <TButton icon='shield' variant='secondary' onClick={open} {...buttonProps}>
        View Permissions
      </TButton>
      <TDrawer opened={viewPermissions} size='xl' title={drawerTitle} onClose={close}>
        {viewPermissions && <PermissionContent entityId={entityId} />}
      </TDrawer>
    </>
  )
}
